import { observable } from "mobx";
import { api, api_adm } from "../../api";
import { toast } from "react-toastify";

export class _StatusStore {

  obs = observable({
    status: [],
    status_length: 0,
    status_all: []
  })

  async handleStatus(page: number, status: string, nome: string, tipo: string) {

    let params = {
      page: page,
      limit: 15,
      status,
      nome,
      tipo,
    }

    try {

      let resp = await api_adm.post('/api/admin/status/index', params)

      this.obs.status_length = 0
      this.obs.status = []

      if (resp.data.itens.length > 0) {
        this.obs.status = resp.data.itens
        this.obs.status_length = resp.data.count
      }

    } catch (ex) { }

  }

  async handleCreateStatus(params: any) {

    try {

      let resp = await api_adm.post('/api/admin/status/create', params)

      if (resp.status == 200) return resp.data

    } catch { }

    return null

  }

  async handleUpdateStatus(params: any) {

    try {

      let resp = await api_adm.post('/api/admin/status/update', params)

      if (resp.data.ok == true) {

        toast.success('Status atualizado com sucesso.', {});

      } else {

        toast.error(resp.data.msg, {});

      }

    } catch { }

  }

  async handleDeleteLocator(id: string) {

    try {

      let resp = await api_adm.delete(`/api/admin/status/${id}`)

      if (resp.data.ok == true) {

        toast.success('Status deletado com sucesso.', {});
        return true

      } else {

        toast.error(resp.data.msg, {});

      }

    } catch { }

    return false

  }

  async handleStatusAll() {

    try {

      let resp = await api.get('/api/status-all')

      this.obs.status_all = []

      if (resp.data.length > 0) {

        this.obs.status_all = resp.data

      }

    } catch (ex) { }

  }

}

export const StatusStore = new _StatusStore();
